import { Link } from "react-router-dom";
import { Car, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ROUTE_PATHS } from "@/routes/routePaths";

export default function OfferARide() {
  return (
    <section className="min-h-[60vh] bg-gradient-to-b from-muted/30 to-background px-4 py-16 sm:py-24">
      <div className="container mx-auto max-w-2xl text-center">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
          <Car className="h-7 w-7 text-primary" />
        </div>
        <h1 className="mb-4 text-3xl font-bold text-foreground sm:text-4xl">Offer a Ride</h1>
        <p className="mb-8 text-muted-foreground sm:text-lg">
          Share empty seats on your route, split fuel and tolls, and meet verified co-travellers.
          See ride requests on your corridor or download the app to publish a ride.
        </p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button asChild className="bg-gradient-to-r from-[#22C55E] to-[#16A34A] text-white">
            <Link to={ROUTE_PATHS.RIDE_REQUESTS}>
              View ride requests <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to={ROUTE_PATHS.HOME}>Back to home</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
